/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Search published posts and public tags while excluding sponsored guest posts */
(function () {
    const modal = document.querySelector('[data-sponsored-search-modal]');
    const input = document.querySelector('#gh-site-search-input');
    const results = document.querySelector('[data-sponsored-search-results]');
    const triggers = document.querySelectorAll('[data-sponsored-search]');
    const closeButtons = document.querySelectorAll('[data-sponsored-search-close]');

    if (!modal || !input || !results || !triggers.length) return;

    const initialVisibleCount = 5;
    const expandedGroups = {
        post: false,
        tag: false,
    };
    const searchCacheKey = 'gh-site-search-index-v5';
    const searchCacheTtl = 10 * 60 * 1000;

    let searchIndexPromise;
    let searchItems = [];
    let isSearchIndexLoading = false;
    let hasSearchIndexLoaded = false;

    function getPostsApiUrl(page) {
        const url = new URL('/ghost/api/content/posts/', window.location.origin);
        url.searchParams.set('key', window.ghostContentApiKey || '');
        url.searchParams.set('limit', '100');
        url.searchParams.set('page', page);
        url.searchParams.set('include', 'authors,tags');
        url.searchParams.set('fields', 'title,url,custom_excerpt,excerpt,published_at');
        url.searchParams.set('filter', 'tag:-hash-sponsored+tag:-hash-wp-post');
        return url;
    }

    function getInitialPostsApiUrl() {
        const url = new URL('/ghost/api/content/posts/', window.location.origin);
        url.searchParams.set('key', window.ghostContentApiKey || '');
        url.searchParams.set('limit', '100');
        url.searchParams.set('page', '1');
        url.searchParams.set('fields', 'title,url,published_at');
        url.searchParams.set('filter', 'tag:-hash-sponsored+tag:-hash-wp-post');
        return url;
    }

    function getTagsApiUrl(page) {
        const url = new URL('/ghost/api/content/tags/', window.location.origin);
        url.searchParams.set('key', window.ghostContentApiKey || '');
        url.searchParams.set('limit', '100');
        url.searchParams.set('page', page);
        url.searchParams.set('fields', 'name,url,slug,description,visibility');
        url.searchParams.set('filter', 'visibility:public');
        return url;
    }

    function getInitialTagsApiUrl() {
        const url = new URL('/ghost/api/content/tags/', window.location.origin);
        url.searchParams.set('key', window.ghostContentApiKey || '');
        url.searchParams.set('limit', '100');
        url.searchParams.set('page', '1');
        url.searchParams.set('fields', 'name,url,slug');
        url.searchParams.set('filter', 'visibility:public');
        return url;
    }

    function escapeHtml(value) {
        return String(value || '').replace(/[&<>"']/g, function (char) {
            return {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;',
            }[char];
        });
    }

    function normalizeSearchText(value) {
        return String(value || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
    }

    function formatDate(value) {
        if (!value) return '';

        return new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
        }).format(new Date(value));
    }

    function readSearchCache() {
        try {
            const cached = JSON.parse(sessionStorage.getItem(searchCacheKey) || 'null');

            if (!cached || !cached.createdAt || !Array.isArray(cached.items)) return null;
            if (Date.now() - cached.createdAt > searchCacheTtl) return null;

            return cached.items;
        } catch (error) {
            return null;
        }
    }

    function writeSearchCache(items) {
        try {
            sessionStorage.setItem(searchCacheKey, JSON.stringify({
                createdAt: Date.now(),
                items: items,
            }));
        } catch (error) {
            // Ignore storage limits and private browsing restrictions.
        }
    }

    function mergeSearchItems(nextItems) {
        let hasChanges = false;
        const itemByUrl = new Map(searchItems.map(function (item) {
            return [item.url, item];
        }));

        nextItems.forEach(function (item) {
            if (!item.url) return;

            if (itemByUrl.has(item.url)) {
                itemByUrl.set(item.url, item);
                hasChanges = true;
                return;
            }

            itemByUrl.set(item.url, item);
            hasChanges = true;
        });

        if (!hasChanges) return;

        searchItems = Array.from(itemByUrl.values());
        renderResults();
    }

    function mapPostToSearchItem(post, isInitialResult) {
        const authors = (post.authors || []).map(function (author) {
            return author.name;
        }).join(' ');
        const tags = (post.tags || []).map(function (tag) {
            return tag.name;
        }).join(' ');
        const searchFields = isInitialResult ? [
            post.title,
        ] : [
            post.title,
            post.custom_excerpt,
            post.excerpt,
            authors,
            tags,
        ];

        return {
            type: 'post',
            title: post.title || '',
            url: post.url,
            excerpt: post.custom_excerpt || post.excerpt || '',
            date: post.published_at,
            haystack: normalizeSearchText(searchFields.join(' ')),
        };
    }

    function mapTagToSearchItem(tag) {
        return {
            type: 'tag',
            title: tag.name || '',
            url: tag.url,
            haystack: normalizeSearchText([
                tag.name,
                tag.slug,
                tag.description,
            ].join(' ')),
        };
    }

    async function fetchPosts() {
        if (!window.ghostContentApiKey) {
            throw new Error('Missing Content API key');
        }

        let page = 1;
        let next = true;
        const allPosts = [];

        while (next && allPosts.length < 10000) {
            const response = await fetch(getPostsApiUrl(page).toString());

            if (!response.ok) {
                throw new Error('Post search request failed');
            }

            const data = await response.json();
            const posts = data.posts || [];
            allPosts.push(...posts);
            mergeSearchItems(posts.map(mapPostToSearchItem));
            next = data.meta && data.meta.pagination && data.meta.pagination.next;
            page += 1;
        }

        return allPosts.map(mapPostToSearchItem);
    }

    async function fetchInitialPosts() {
        if (!window.ghostContentApiKey) {
            throw new Error('Missing Content API key');
        }

        const response = await fetch(getInitialPostsApiUrl().toString());

        if (!response.ok) {
            throw new Error('Initial post search request failed');
        }

        const data = await response.json();
        const posts = (data.posts || []).map(function (post) {
            return mapPostToSearchItem(post, true);
        });

        mergeSearchItems(posts);

        return posts;
    }

    async function fetchTags() {
        if (!window.ghostContentApiKey) {
            throw new Error('Missing Content API key');
        }

        let page = 1;
        let next = true;
        const allTags = [];

        while (next && allTags.length < 10000) {
            const response = await fetch(getTagsApiUrl(page).toString());

            if (!response.ok) {
                throw new Error('Tag search request failed');
            }

            const data = await response.json();
            const tags = data.tags || [];
            allTags.push(...tags);
            mergeSearchItems(tags.map(mapTagToSearchItem));
            next = data.meta && data.meta.pagination && data.meta.pagination.next;
            page += 1;
        }

        return allTags.map(mapTagToSearchItem);
    }

    async function fetchInitialTags() {
        if (!window.ghostContentApiKey) {
            throw new Error('Missing Content API key');
        }

        const response = await fetch(getInitialTagsApiUrl().toString());

        if (!response.ok) {
            throw new Error('Initial tag search request failed');
        }

        const data = await response.json();
        const tags = (data.tags || []).map(mapTagToSearchItem);

        mergeSearchItems(tags);

        return tags;
    }

    async function fetchSearchIndex() {
        const items = await Promise.all([
            fetchPosts(),
            fetchTags(),
        ]);

        return items.flat();
    }

    async function fetchInitialSearchIndex() {
        const items = await Promise.all([
            fetchInitialPosts(),
            fetchInitialTags(),
        ]);

        return items.flat();
    }

    function getMatchRank(item, query) {
        const title = normalizeSearchText(item.title);

        if (title === query) return 0;
        if (title.startsWith(query)) return 1;
        if (item.haystack.includes(query)) return 2;

        return 3;
    }

    function sortMatches(a, b, query) {
        const rankDifference = getMatchRank(a, query) - getMatchRank(b, query);

        if (rankDifference !== 0) return rankDifference;

        if (a.type === 'post' && b.type === 'post') {
            return new Date(b.date || 0) - new Date(a.date || 0);
        }

        return a.title.localeCompare(b.title);
    }

    function renderResultItem(item) {
        const label = item.label || formatDate(item.date);
        const labelHtml = label ? '<span>' + escapeHtml(label) + '</span>' : '';

        return [
            '<a class="gh-site-search-result" href="' + escapeHtml(item.url) + '">',
                labelHtml,
                '<h3>' + escapeHtml(item.title) + '</h3>',
            '</a>',
        ].join('');
    }

    function renderResultSection(title, type, items) {
        if (!items.length) return '';

        const visibleItems = expandedGroups[type] ? items : items.slice(0, initialVisibleCount);
        const remainingCount = items.length - visibleItems.length;
        const button = remainingCount > 0 ? [
            '<button class="gh-site-search-more" type="button" data-sponsored-search-more="' + escapeHtml(type) + '">',
                'Show more ' + escapeHtml(title.toLowerCase()) + ' (' + remainingCount + ')',
            '</button>',
        ].join('') : '';

        return [
            '<section class="gh-site-search-section">',
                '<h2>' + escapeHtml(title) + '</h2>',
                visibleItems.map(renderResultItem).join(''),
                button,
            '</section>',
        ].join('');
    }

    function renderIdle() {
        results.innerHTML = '<p class="gh-site-search-empty">Start typing to search published posts and tags.</p>';
    }

    function renderLoading() {
        results.innerHTML = '<p class="gh-site-search-empty">Loading search index...</p>';
    }

    function renderError() {
        results.innerHTML = '<p class="gh-site-search-empty">Search is unavailable right now.</p>';
    }

    function renderResults() {
        const query = normalizeSearchText(input.value.trim());

        if (!query) {
            renderIdle();
            return;
        }

        if (!searchItems.length && (isSearchIndexLoading || !hasSearchIndexLoaded)) {
            results.innerHTML = '<p class="gh-site-search-empty">Please wait. Search loading.</p>';
            return;
        }

        const terms = query.split(/\s+/).filter(Boolean);
        const matches = searchItems.filter(function (item) {
            return terms.every(function (term) {
                return item.haystack.includes(term);
            });
        }).sort(function (a, b) {
            return sortMatches(a, b, query);
        });

        if (!matches.length) {
            results.innerHTML = '<p class="gh-site-search-empty">No results found.</p>';
            return;
        }

        const tags = matches.filter(function (item) {
            return item.type === 'tag';
        });
        const posts = matches.filter(function (item) {
            return item.type === 'post';
        });

        results.innerHTML = [
            renderResultSection('Tags', 'tag', tags),
            renderResultSection('Posts', 'post', posts),
        ].join('');
    }

    function loadSearchIndex() {
        if (searchItems.length) {
            renderResults();
            return Promise.resolve(searchItems);
        }

        if (!searchIndexPromise) {
            const cachedItems = readSearchCache();

            if (cachedItems) {
                searchItems = cachedItems;
                hasSearchIndexLoaded = true;
                renderResults();
                return Promise.resolve(searchItems);
            }

            if (!modal.hidden) renderLoading();
            isSearchIndexLoading = true;
            searchIndexPromise = fetchInitialSearchIndex()
                .catch(function () {
                    return [];
                })
                .then(fetchSearchIndex)
                .then(function (items) {
                    searchItems = items;
                    hasSearchIndexLoaded = true;
                    writeSearchCache(items);
                    renderResults();
                    return searchItems;
                })
                .catch(function () {
                    if (!modal.hidden) renderError();
                })
                .finally(function () {
                    isSearchIndexLoading = false;
                });
        }

        return searchIndexPromise;
    }

    function openSearch(event) {
        if (event) event.preventDefault();
        modal.hidden = false;
        document.documentElement.classList.add('has-search-open');
        input.focus();
        renderIdle();
        loadSearchIndex();
    }

    function closeSearch() {
        modal.hidden = true;
        document.documentElement.classList.remove('has-search-open');
    }

    triggers.forEach(function (trigger) {
        trigger.addEventListener('click', openSearch);
        trigger.addEventListener('pointerenter', loadSearchIndex, {once: true});
        trigger.addEventListener('focus', loadSearchIndex, {once: true});
    });

    closeButtons.forEach(function (button) {
        button.addEventListener('click', closeSearch);
    });

    input.addEventListener('input', function () {
        expandedGroups.post = false;
        expandedGroups.tag = false;
        renderResults();
    });

    results.addEventListener('click', function (event) {
        const button = event.target.closest('[data-sponsored-search-more]');

        if (!button) return;

        expandedGroups[button.dataset.sponsoredSearchMore] = true;
        renderResults();
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !modal.hidden) {
            closeSearch();
        }

        if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
            openSearch(event);
        }
    });

    window.addEventListener('hashchange', function () {
        if (window.location.hash === '#/search') {
            openSearch();
        }
    });

    if (window.location.hash === '#/search') {
        openSearch();
    }
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
